import { ApolloClient, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

import { notificationService } from "../services/notificationService";

const errorLink = onError(({ networkError, graphQLErrors, operation }) => {
  if (networkError) {
    if (!("statusCode" in networkError)) {
      notificationService.danger({
        msg: `[GraphQL network error] ${operation.operationName}: ${networkError.message}`,
      });
      console.error(
        `[GraphQL network error] ${operation.operationName}`,
        networkError
      );
    } else if (
      networkError.statusCode === 401 ||
      networkError.statusCode === 403
    ) {
      const urlObj = new URL(window.location.href);
      const pathSegments = urlObj.pathname.split("/").filter(Boolean);
      const currentLang =
        pathSegments.length > 0 && pathSegments[0].length === 2
          ? "/" + pathSegments[0]
          : "";
      window.location.href = `${process.env.REACT_APP_TICKET_URL}${currentLang}/for-organizers/login`;
    } else if (networkError.statusCode >= 500) {
      notificationService.danger({
        msg: `[GraphQL network error] ${operation.operationName}: ${networkError.statusCode}`,
      });
      console.error(
        `[GraphQL network error] ${operation.operationName}: ${networkError.statusCode}`,
        networkError
      );
    }
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(`[GraphQL error] ${operation.operationName}: ${message}`, {
        locations,
        path,
      });
      notificationService.danger({ msg: message });
    });
  }
});

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_TICKET_URL + "/for-organizers/graphql",
  credentials: "include",
});

const localeLink = setContext((_, { headers }) => {
  const [locale] = window.location.pathname.split("/").filter(Boolean);

  return {
    headers: {
      ...headers,
      "x-locale": locale?.length === 2 ? locale : "en",
    },
  };
});

export const apolloClient = new ApolloClient({
  link: errorLink.concat(localeLink).concat(uploadLink),
  cache: new InMemoryCache({
    typePolicies: {
      ImageProxyType: {
        keyFields: ["fileName"],
      },
    },
  }),
});
